import { Check, X } from 'lucide-react'
import Card from 'app/frontend/base/components/Card'
import { imageUrl } from 'app/frontend/base/helpers'
import { capitalize } from 'lodash'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { ActivityAssignmentViewModel } from './activityAssignmentViewModel'
import { useDifficulties } from 'app/frontend/base/hooks/useDifficulties'

type Props = {
  viewModel: ActivityAssignmentViewModel
  isActive: boolean
  onClick: () => void
}

const DialogEncounterCard = ({ viewModel, isActive, onClick }: Props) => {
  const { hasDifficulties } = useDifficulties()
  const { activity, isSelected, totalAbilityCount } = viewModel
  const encounterName =
    activity.encounter?.name ||
    activity.instance?.name ||
    capitalize(activity.activityType)

  return (
    <div className='relative flex w-11 min-w-0 sm:w-auto sm:flex-1 sm:basis-0'>
      {totalAbilityCount > 0 ? (
        <Badge
          variant='info'
          className='pointer-events-none border-info-foreground border absolute -right-2 -top-2 z-10 h-8 min-w-8 justify-center px-1.5 text-sm tabular-nums'
        >
          {totalAbilityCount}
        </Badge>
      ) : null}
      <Card
        className={cn(
          'flex w-full min-w-0 cursor-pointer flex-col overflow-hidden p-0 transition-colors sm:flex-row sm:flex-wrap sm:items-center sm:justify-center sm:gap-1.5 sm:p-2',
          isActive
            ? 'border-primary hover:border-primary'
            : 'hover:border-primary/50',
        )}
        onClick={onClick}
      >
        <div className='relative w-full shrink-0 overflow-hidden sm:w-14 sm:rounded-md'>
          <img
            src={
              activity.encounter?.thumbnailUrl ??
              activity.instance?.thumbnailUrl ??
              activity.instance?.tileUrl ??
              imageUrl(`activity-thumbnails/${activity.activityType}.jpg`)
            }
            className={cn(
              'h-11 w-full object-cover sm:h-14',
              !isSelected && 'grayscale opacity-60',
            )}
          />
          {hasDifficulties ? (
            <div className='absolute bottom-0 right-0 rounded-tl-[8px] bg-card-nested/70 px-1 py-0.5 text-xs font-semibold leading-none'>
              {activity.difficulty?.[0].toUpperCase() ?? '-'}
            </div>
          ) : null}
        </div>
        <div className='flex min-w-0 flex-col items-center justify-center gap-1 p-1.5 sm:flex-1 sm:basis-16 sm:flex-row sm:gap-1.5 sm:p-0'>
          {isSelected ? (
            <Check className='h-4 w-4 shrink-0 text-success-foreground sm:h-6 sm:w-6' />
          ) : (
            <X className='h-4 w-4 shrink-0 text-destructive-foreground sm:h-6 sm:w-6' />
          )}
          <span
            className={cn(
              'hidden truncate text-sm font-medium sm:block',
              !isSelected && 'opacity-50 grayscale',
            )}
          >
            {encounterName}
          </span>
        </div>
      </Card>
    </div>
  )
}

export default DialogEncounterCard
